var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: !_vm.custom || _vm.custom.searchList.length === 0,
          expression: "!custom || custom.searchList.length===0"
        }
      ],
      staticClass: "dynamic-query",
      attrs: { "element-loading-spinner": "none" }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "search-form custom-form",
          attrs: { model: _vm.form, inline: true }
        },
        [
          _vm.isUltimate
            ? _c(
                "el-form-item",
                { key: "index", attrs: { label: "分支机构" } },
                [
                  _c("ybl-multi-select", {
                    attrs: {
                      items: _vm.partner.branchList,
                      props: _vm.partner.props,
                      placeholder: "请选择分支机构",
                      clearable: "",
                      filterable: "",
                      "filter-method": _vm.filterPartner
                    },
                    on: {
                      focus: _vm.focusPartner,
                      change: function($event) {
                        return _vm.partnerChange($event)
                      }
                    },
                    model: {
                      value: _vm.partner.defaultVal,
                      callback: function($$v) {
                        _vm.$set(_vm.partner, "defaultVal", $$v)
                      },
                      expression: "partner.defaultVal"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.custom.searchList, function(item, index) {
            return [
              +item.frontEleType === 11
                ? _c("ybl-date-time", {
                    key: index,
                    attrs: { diff: 2, unit: "y" },
                    model: {
                      value: item.defaultVal,
                      callback: function($$v) {
                        _vm.$set(item, "defaultVal", $$v)
                      },
                      expression: "item.defaultVal"
                    }
                  })
                : _c(
                    "el-form-item",
                    {
                      key: index,
                      class: {
                        "ultimate-item": _vm.isUltimate && index === 0,
                        "el-form-item__long": item.showName.length >= 18
                      },
                      attrs: { label: "" + item.showName }
                    },
                    [
                      +item.id === 1533 ||
                      item.tableName + "_" + item.fieldName ===
                        "insuranceinfo_InsuranceTypes"
                        ? _c("ybl-insurance-type", {
                            attrs: {
                              showCheckbox: +item.isMutiSelect === 1,
                              placeholder: "请选择" + item.showName
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : +item.id === 1575
                        ? _c("ybl-insurance-type", {
                            attrs: {
                              showCheckbox: true,
                              dataType: 4,
                              placeholder: "请选择" + item.showName,
                              props: _vm.props
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : [10].includes(+item.frontEleType) &&
                          ![1533, 1575].includes(+item.id)
                        ? _c("ybl-select-tree", {
                            ref: "stree_" + item.id,
                            refInFor: true,
                            attrs: {
                              items: item.dictList,
                              props: _vm.treeDefaultProps,
                              placeholder: "请选择" + item.showName,
                              clearable: ""
                            },
                            on: {
                              clear: function($event) {
                                return _vm.treeClear(item)
                              }
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : item.isTabFilter
                        ? _c("ybl-radio-group", {
                            attrs: {
                              label: "",
                              checked: item.defaultVal,
                              showClose: true,
                              options: item.dictList,
                              props: _vm.defaultProps,
                              "label-width": "100px"
                            },
                            on: {
                              "update:checked": function($event) {
                                return _vm.$set(item, "defaultVal", $event)
                              },
                              change: _vm.radioChange
                            }
                          })
                        : [2, 3].includes(+item.frontEleType) &&
                          +item.isMutiSelect === 1
                        ? _c("ybl-multi-select", {
                            attrs: {
                              items: item.dictList,
                              props:
                                +item.sourceType === 2
                                  ? _vm.staticProps
                                  : _vm.jobnumProps,
                              placeholder: "请选择" + item.showName,
                              clearable: "",
                              filterable: "",
                              "filter-method": _vm.filterEvent
                            },
                            on: {
                              focus: function($event) {
                                return _vm.focusEvent(item)
                              },
                              change: function($event) {
                                return _vm.relationChange($event, item)
                              }
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : [2, 3].includes(+item.frontEleType) &&
                          +item.isMutiSelect === 0
                        ? _c(
                            "el-select",
                            {
                              ref: item.id,
                              refInFor: true,
                              attrs: {
                                placeholder: "请选择" + item.showName,
                                filterable: true,
                                clearable: "",
                                "filter-method": _vm.filterEvent
                              },
                              on: {
                                focus: function($event) {
                                  return _vm.focusEvent(item)
                                }
                              },
                              model: {
                                value: item.defaultVal,
                                callback: function($$v) {
                                  _vm.$set(item, "defaultVal", $$v)
                                },
                                expression: "item.defaultVal"
                              }
                            },
                            _vm._l(item.dictList, function(o) {
                              return _c("el-option", {
                                key: o.keyCode || o.Value,
                                attrs: {
                                  label: _vm.getLabel(item, o),
                                  value: o.keyCode || o.Value
                                }
                              })
                            }),
                            1
                          )
                        : item.frontEleType === 8
                        ? _c("ybl-date-range", {
                            attrs: { diff: 2, unit: "y" },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : item.frontEleType === 7
                        ? _c("el-date-picker", {
                            attrs: { type: "date", placeholder: "选择日期" },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : +item.frontEleType === 5
                        ? _c("ybl-area", {
                            attrs: { labels: ["", "", ""], level: 2 },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : +item.frontEleType === 6
                        ? _c("ybl-area", { attrs: { labels: ["", "", ""] } })
                        : +item.frontEleType === 9
                        ? _c("ybl-num-range", {
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                        : _c("el-input", {
                            attrs: {
                              type: "text",
                              placeholder: "请输入" + item.showName,
                              clearable: ""
                            },
                            model: {
                              value: item.defaultVal,
                              callback: function($$v) {
                                _vm.$set(item, "defaultVal", $$v)
                              },
                              expression: "item.defaultVal"
                            }
                          })
                    ],
                    1
                  )
            ]
          }),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "" } },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.search } },
                [_vm._v("查询")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.reset } }, [_vm._v("重置")]),
              _vm._v(" "),
              _c(
                "el-link",
                { attrs: { type: "primary" }, on: { click: _vm.open } },
                [
                  _vm._v("条件设置"),
                  _c("i", {
                    staticClass: "el-icon-edit-outline el-icon--right"
                  })
                ]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ybl-list-panel",
        { attrs: { title: _vm.title } },
        [
          _c("template", { slot: "header" }, [
            _c(
              "div",
              [
                _vm.showTask && !_vm.isdataauthority
                  ? _vm._t("header-left", function() {
                      return [
                        _vm.isFeiche
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.goToRouter(
                                      "/feiche/policy/task?showType=delete"
                                    )
                                  }
                                }
                              },
                              [_vm._v("任务列表\n          ")]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function($event) {
                                    return _vm.goToRouter(
                                      "/insurance/task?busiType=" +
                                        _vm.sceneCategory
                                    )
                                  }
                                }
                              },
                              [_vm._v("任务列表\n          ")]
                            )
                      ]
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { class: { "custom-action": _vm.showExport } },
              [
                _vm._t("custom-action"),
                _vm._v(" "),
                _vm.showExport
                  ? _c(
                      "el-dropdown",
                      {
                        directives: [
                          {
                            name: "authority",
                            rawName: "v-authority",
                            value: _vm.exportAuthority,
                            expression: "exportAuthority"
                          }
                        ],
                        attrs: { type: "primary", "hide-on-click": false },
                        on: { command: _vm.handleCommand }
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("\n            保单导出"),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "none" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "text",
                                    clearable: "",
                                    placeholder: "请输入模版名称进行检索"
                                  },
                                  on: { input: _vm.inputChange },
                                  model: {
                                    value: _vm.templateVal,
                                    callback: function($$v) {
                                      _vm.templateVal = $$v
                                    },
                                    expression: "templateVal"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.templateList, function(item, index) {
                              return _c(
                                "el-dropdown-item",
                                {
                                  key: item.id,
                                  attrs: {
                                    command: item.id,
                                    divided: index === 0
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.sceneName) + "\n            "
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c("el-dropdown-item", {
                              key: "item.id",
                              attrs: { command: "item.id", divided: "" }
                            }),
                            _vm._v(" "),
                            !_vm.isFeiche && +_vm.dynamicQueryType !== 4
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "authority",
                                        rawName: "v-authority",
                                        value: _vm.customExportTemplate,
                                        expression: "customExportTemplate"
                                      }
                                    ],
                                    key: "addTemplate",
                                    attrs: {
                                      divided: false,
                                      icon: "el-icon-plus",
                                      command: "addTemplate"
                                    }
                                  },
                                  [_vm._v("自定义表头")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                ![4].includes(+_vm.dynamicQueryType)
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.openColumn }
                      },
                      [_vm._v("列表字段设置")]
                    )
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "summary-info" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _c(
            "ybl-table",
            {
              ref: "dynamicTable",
              attrs: {
                data: _vm.queryList,
                border: "",
                total: _vm.queryTotal,
                change: _vm.pageChange,
                nowrap: true
              },
              on: {
                "selection-change": _vm.handleSelectionChange,
                "size-change": _vm.sizeChange
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: _vm.type,
                  align: "center",
                  fixed: "left",
                  label: "序号"
                }
              }),
              _vm._v(" "),
              _vm.isUltimate
                ? _c("el-table-column", {
                    attrs: {
                      label: "分支机构",
                      align: "center",
                      "min-width": "100",
                      fixed: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(scope.row.fields["666"]) +
                                  "\n        "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1170943388
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.custom.availableList, function(item, index) {
                return [
                  ![1578, 1579, 1580, 1577, 1582, 1581, 1576].includes(item.id)
                    ? _c("el-table-column", {
                        key: "column_" + index,
                        attrs: {
                          label: item.showName,
                          align: "center",
                          "min-width": "120",
                          "show-overflow-tooltip": "",
                          prop: "" + item.id,
                          fixed: index < 2
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(scope) {
                                return [
                                  [2, 3, 10].includes(+item.frontEleType)
                                    ? [
                                        _vm.isFeiche
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.fields[item.id]
                                                )
                                              )
                                            ])
                                          : _c(
                                              "span",
                                              {
                                                class: {
                                                  red:
                                                    [
                                                      1277,
                                                      1282,
                                                      1562,
                                                      1563
                                                    ].includes(item.id) &&
                                                    +scope.row.fields[
                                                      item.id
                                                    ] === 0
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.calcFieldText(
                                                      item.id,
                                                      scope.row,
                                                      item,
                                                      scope.$index
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                      ]
                                    : +item.showFormatType === 1
                                    ? [
                                        item.tableName +
                                          "_" +
                                          item.fieldName ===
                                          "insurancesettle_RewardSettleRate" &&
                                        +_vm.dynamicQueryType === 4
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    _vm._f("percent")(
                                                      scope.row.fields[item.id]
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-caret-bottom cursor",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openView(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              })
                                            ])
                                          : _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm._f("percent")(
                                                    scope.row.fields[item.id]
                                                  )
                                                )
                                              )
                                            ])
                                      ]
                                    : +item.showFormatType === 2
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("dateFormat")(
                                                scope.row.fields[item.id]
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    : +item.showFormatType === 3
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm._f("Currency")(
                                                scope.row.fields[item.id]
                                              )
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    : +item.id === 1166
                                    ? [
                                        _vm.isUltimate
                                          ? _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  scope.row.fields[item.id]
                                                )
                                              )
                                            ])
                                          : _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "cursor primary-color",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.goToDetail(
                                                      scope.row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.fields[item.id]
                                                  )
                                                )
                                              ]
                                            )
                                      ]
                                    : [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(scope.row.fields[item.id]) +
                                            "\n            "
                                        )
                                      ]
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _vm._e()
                ]
              }),
              _vm._v(" "),
              _vm.showRelation
                ? _c("el-table-column", {
                    directives: [
                      { name: "isdataauthority", rawName: "v-isdataauthority" }
                    ],
                    attrs: {
                      label: "关联政策",
                      align: "center",
                      "min-width": "100"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("el-button", {
                                class: {
                                  disabled: !_vm.renderPolicy(scope.row)
                                },
                                attrs: {
                                  type: "text",
                                  icon: "el-icon-paperclip"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.viewPolicy(scope.row)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3244902801
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("action")
            ],
            2
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.dialog.visible,
            title: _vm.dialog.title,
            width: _vm.dialog.width,
            showFooter:
              ![17, 50, 400].includes(+_vm.dialog.step) || _vm.isBindQrcode,
            showHeader: ![50].includes(+_vm.dialog.step)
          },
          on: { close: _vm.close, confirm: _vm.dialogSubmit }
        },
        [
          +_vm.dialog.step < 3
            ? _c("ybl-condition", {
                ref: "dialog",
                attrs: {
                  fields: _vm.system[_vm.renderField],
                  groupCheckBox: +_vm.dialog.step === 2
                },
                on: { change: _vm.submit },
                model: {
                  value: _vm.custom[_vm.renderField],
                  callback: function($$v) {
                    _vm.$set(_vm.custom, _vm.renderField, $$v)
                  },
                  expression: "custom[renderField]"
                }
              })
            : +_vm.dialog.step === 40
            ? _c("template-fields", {
                ref: "dialog",
                attrs: {
                  item: _vm.currentTemplate,
                  templates: _vm.originTemplateList
                },
                on: { change: _vm.submitTemplate }
              })
            : +_vm.dialog.step === 400
            ? _c("ybl-qrcode", {
                ref: "dialog",
                on: { next: _vm.nextValidate }
              })
            : _c("ybl-export", {
                ref: "dialog",
                attrs: {
                  taskId: _vm.taskId,
                  isFeiche: _vm.isFeiche,
                  busiType: _vm.sceneCategory
                },
                on: { close: _vm.close, goTo: _vm.goTo }
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e89f79", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e89f79","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicQuery.vue
// module id = null
// module chunks = 